module.exports = __webpack_public_path__ + "img/check-black.ba17ada7.svg";